module.exports = __webpack_public_path__ + "static/media/tmp.da6e0a1d.mp4";